import {
    ALL_ANIMATED_FILE_EXTENSIONS,
    ALL_ANIMATED_MIME_TYPES,
    FILE_EXTENSIONS_MIME_TYPE_MAP,
    VIDEO_FILE_EXTENSIONS,
    VIDEO_MIME_TYPES,
} from '../constants'
import { CreationToolSourceInfo } from '../types'

export const getUrlExtension = (url: string): string => {
    if (url.indexOf('youtube.com') > -1 || url.indexOf('youtu.be') > -1) {
        return 'youtube'
    }

    if (url.indexOf('vimeo.com') > -1) {
        return 'vimeo'
    }

    if (url.indexOf('imaging.giphy.com') > -1) {
        if (url.indexOf('fmt=mp4') > -1) {
            return '.mp4'
        }
        return '.gif'
    }

    return `.${url.split('?')[0].split('.').pop()}`
}

export const getUrlMimeType = (url: string): string => {
    const ext = getUrlExtension(url)
    return FILE_EXTENSIONS_MIME_TYPE_MAP[ext] || ''
}

const getSourceInfo = (source: File | string): CreationToolSourceInfo => {
    const isUrl = typeof source === 'string'
    const fileType = isUrl ? getUrlExtension(source as string) : (source as File).type
    const isVideo = isUrl ? VIDEO_FILE_EXTENSIONS.indexOf(fileType) > -1 : VIDEO_MIME_TYPES.indexOf(fileType) > -1
    const isAnimated = isUrl
        ? ALL_ANIMATED_FILE_EXTENSIONS.indexOf(fileType) > -1
        : ALL_ANIMATED_MIME_TYPES.indexOf(fileType) > -1

    return {
        isUrl,
        isVideo,
        isAnimated,
    }
}

export default getSourceInfo
